import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import locationPng from '../../assets/location.png';
import { slugify } from '../../utils/slugify';
import bedPng from "../../assets/bed.png";
import bathtubPng from "../../assets/bathtub.png";
import scalePng from "../../assets/scale.png";

const Content = ({ data }) => {
  const [index, setIndex] = useState(0);
  const [buyRealEstate, setBuyRealEstate] = useState([]);
  const propertiesPerPage = 9;
  const navigate = useNavigate();

  useEffect(() => {
    setBuyRealEstate(data.filter((property) => property.status === 'approved'));
    console.log("Data ", data);
  }, [data]);

  const totalPages = Math.ceil(buyRealEstate.length / propertiesPerPage);

  const handleClick = (property) => {
    navigate(`/property/${slugify(property.name)}`);
  };

  const renderProperties = (startIndex) => {
    return buyRealEstate
      .slice(startIndex, startIndex + propertiesPerPage)
      .map((property, key) => (
        <div
          key={key}
          className="px-8 pb-8 w-[90vw] md:w-[45vw] lg:w-[30vw]"
          onClick={() => handleClick(property)}
        >
          <div className="border border-[#E9E9E9]-400  rounded shadow-md p-1">
            <div className="relative overflow-hidden">
              <img
                src={property.images[0]}
                alt="dubaiPhoto"
                className="h-[40vh] object-cover w-[100%] rounded-sm duration-300 hover:scale-[1.2]"
              />
            </div>
            <div className="flex flex-col px-[3%]">
              <div className="flex justify-between items-center">
                <div className="text-left font-semibold text-lg pt-4 text-black">
                  {property?.name ? property.name.replace(/[-\d]/g, " ") : ""}
                </div>
                <div className="pt-4 font-semibold text-black lg:text-md">
                  {property.price > 0 ? property.price + " AED" : "Contact Us"}
                </div>
              </div>
              <div className="flex  py-2">
                <div className="flex flex-col">
                  <div className="text-base md:text-lg text-left font-semibold flex justify-center items-center">
                    <div>{property.bedrooms}</div>
                    <img
                      src={bedPng}
                      alt="bed"
                      className="md:w-8 md:h-8 w-4 h-4 mx-2"
                    />
                  </div>
                </div>
                <div className="flex flex-col mx-4">
                  <div className="text-base md:text-lg text-left font-semibold flex justify-center items-center">
                    <div>{property.bathrooms}</div>
                    <img
                      src={bathtubPng}
                      alt="bed"
                      className="md:w-8 md:h-8 w-4 h-4 mx-2"
                    />
                  </div>
                </div>
                <div className="flex flex-col">
                  <div className="text-base md:text-lg text-left font-semibold flex justify-center items-center">
                    <div>{property.square}</div>
                    <img
                      src={scalePng}
                      alt="bed"
                      className="md:w-8 md:h-8 w-4 h-4 mx-2"
                    />
                  </div>
                </div>
              </div>
              <div className="text-left py-1 text-sm text-gray-400 flex items-center">
                <img src={locationPng} alt="location" className="w-4 m-1" />
                <div>{property.location}</div>
              </div>
            </div>
          </div>
        </div>
      ));
  };

  return (
    <div className="relative *:font-sans">
      <div className="my-5 font-semibold text-left ml-[7%] text-3xl">
        {data.length === 0 ? 'No Properties Available!' : `Properties`}
      </div>
      <div className="flex flex-col justify-center flex-wrap items-center md:flex-row">
        {renderProperties(index * propertiesPerPage)}
      </div>
      <div className="relative mb-12 mx-auto flex justify-center sm:my-[2%]">
        {Array.from({ length: totalPages }, (_, i) => (
          <div
            key={i}
            onClick={() => setIndex(i)}
            className={`mx-2 px-6 py-5 border border-black duration-300 cursor-pointer ${index === i
                ? 'bg-black text-white'
                : 'hover:bg-black hover:text-white'
              }`}
          >
            {i + 1}
          </div>
        ))}
      </div>
    </div>
  );
};

export default Content;
